import styled from 'styled-components';

export const RelatoriosContainer = styled.div`
  width: 100%;
`;

export const RelatoriosTitle = styled.h1`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.primaryColor};
  font-size: 24px;
`;

export const RelatoriosContent = styled.div`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  gap: 16px;
  flex-grow: 1;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 24px;
`;

export const TableContainer = styled.div`
  margin-top: 24px;
  overflow-x: auto;
`;

export const ErrorContainer = styled.div`
  color: ${({ theme }) => theme.dangerColor};
  margin-top: 16px;
  padding: 12px;
  background-color: ${({ theme }) => theme.dangerLightColor || '#ffeeee'};
  border-radius: 4px;
  margin-bottom: 24px;
`;

export const ChartContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 24px;
  width: 100%;
  height: 500px;
`;

export const ChartWrapper = styled.div`
  background-color: ${({ theme }) => theme.white};
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const ChartTitle = styled.h3`
  color: ${({ theme }) => theme.primaryColor};
  margin-bottom: 16px;
  text-align: center;
`;

export const NoDataContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  width: 100%;
  background-color: ${({ theme }) => theme.lightGray || '#f8f9fa'};
  color: ${({ theme }) => theme.gray};
  border-radius: 8px;
  font-size: 16px;
`;

export const LegendText = styled.span`
  color: ${({ theme }) => theme.textColor};
  font-weight: 500;
`;
